import React from 'react';
import PropTypes from 'prop-types';
import { Route, Switch } from 'react-router-dom';
import { NoMatchPage } from '../../configs/routes';
import { RouterContext } from './MainContainer';

const ParentContainerRoute = ({
  routes
}) => {
  return (
    <Switch>
      {routes.map(({ component: Component, exact, path, ...rest }) => {
        return (
          <Route
            key={path}
            exact={exact}
            path={path}
            render={() => <Component parentPath={path} {...rest} />}
          />
        );
      })}

      {
        // autoRedirect && (
        //   <Redirect exact={true} from={parentPath + '/'} to={redirectTo} />
        // )
      }
      <Route component={NoMatchPage} />
    </Switch>
  );
};

ParentContainerRoute.defaultProps = {
  parentPath: '',
  autoRedirect: true
};

ParentContainerRoute.propTypes = {
  pathname: PropTypes.string.isRequired,
  routes: PropTypes.arrayOf(
    PropTypes.shape({
      path: PropTypes.string.isRequired,
      component: PropTypes.any.isRequired,
      routes: PropTypes.array
    })
  ).isRequired,

  parentPath: PropTypes.string,
  autoRedirect: PropTypes.bool,
  redirect: PropTypes.string
};

export default props => (
  <RouterContext.Consumer>
    {// workaround to fix issue #5500 of ReactRouter
      ({ location: { pathname } }) => (
        <ParentContainerRoute {...props} pathname={pathname} />
      )}
  </RouterContext.Consumer>
);
